import moment from 'moment';
import { InvestigationSourceTypesMap } from '@usealloy/typegen';

export const INVESTIGATION_STATES = {
  ALERT_REVIEW: 'Alert Review',
  CASE_REVIEW: 'Case Review',
} as const;

export const CHECK_JOURNEY_ALERT_STATUS_ATTEMPTS = 10;
export const CHECK_JOURNEY_ALERT_STATUS_INTERVAL = 1_000;

// Specific Investigation error messages from API that we match against for specific UI messaging
export const CURRENT_AGENT_CLOSE_ERROR = 'Only the current assigned agent can close an Investigation';
export const CURRENT_AGENT_PROMOTE_ERROR = 'Only the current assigned agent can promote an Investigation';
export const INVESTIGATION_OPEN_ALERTS_CLOSE_ERROR = 'Cannot close an Investigation with open Alerts';

// Investigation error messages to display
export const INVESTIGATION_OPEN_ALERTS_CLOSE = 'This Investigation still has open Alerts and cannot be closed';

export const HARDCODED_INV_ERRORS = new Set([
  CURRENT_AGENT_CLOSE_ERROR,
  CURRENT_AGENT_PROMOTE_ERROR,
  INVESTIGATION_OPEN_ALERTS_CLOSE,
  INVESTIGATION_OPEN_ALERTS_CLOSE_ERROR,
]);

export const INVESTIGATION_REVIEW_ALLOWED_OUTCOMES = [
  'Confirmed Risk',
  'Dismissed',
] as const;

export const INVESTIGATION_QUEUE_INITIAL_FILTER_VALUES = {
  createdAtFrom: moment().subtract(30, 'days').toISOString(),
  createdAtTo: moment().endOf('day').toISOString(),
  archived: 'false',
};

export const MANUAL_INVESTIGATION_TYPES = new Set([
  InvestigationSourceTypesMap.MANUAL_AGENT,
  InvestigationSourceTypesMap.MANUAL_API,
]);

export const INVESTIGATION_AUTO_ASSIGN = 'auto-assign';

export const TAGS_AND_OUTCOME_REASONS_LABEL = 'Tags and Outcome Reasons';

/** Filters that have been replaced with newer keys but may still be present in saved searches */
export const DEPRECATED_FILTER_KEYS = ['tags', 'outcomeReasons'] as const;

export const DEPRECATED_FILTER_MAPPING = {
  tags: TAGS_AND_OUTCOME_REASONS_LABEL,
  outcomeReasons: TAGS_AND_OUTCOME_REASONS_LABEL,
} satisfies Record<(typeof DEPRECATED_FILTER_KEYS)[number], string>;
